module.exports = __webpack_public_path__ + "img/c2b285a89c159629b20aeb30a925328a.png";